import React from 'react';
import "./Admin.css";
export default function Admin() {
  return <h1 className='admin'>ADMIN</h1>;
}